module.exports = __webpack_public_path__ + "static/media/microbit-front.1306cd70.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/microbit-front.png
// module id = 34
// module chunks = 0